export interface OtpCheck {
  valid: boolean;
  state: string;
}
